import { useState, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from '../components/Sidebar.jsx'
import TopBar from '../components/TopBar.jsx'
import ToastContainer from '../components/Toast.jsx'
import { useThemeStore } from '../stores/themeStore.js'

const pageTitles = {
  '/': 'Dashboard',
  '/vehicles': 'My Vehicles',
  '/expenses': 'Expenses',
  '/analytics': 'Analytics',
  '/profile': 'Profile',
  '/invitations': 'Invitations',
  '/subscription': 'Subscription',
}

const AppLayout = () => {
  const location = useLocation()
  const [collapsed, setCollapsed] = useState(false)
  const darkMode = useThemeStore((s) => s.darkMode)

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [darkMode])

  const title = pageTitles[location.pathname] || 'CarFile'

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white transition-colors">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className={`transition-all duration-300 ${collapsed ? 'ml-[72px]' : 'ml-64'}`}>
        <TopBar title={title} />
        <main className="p-6">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
      <ToastContainer />
    </div>
  )
}

export default AppLayout
